import { Link, Typography } from "@mui/material";
import { Links } from "../../constants";
import { FeedItemDto, type FeedItemIssueCollaboratorsValueDto } from "../../http";

interface IProps {
  feedItem: FeedItemDto;
}

const IssueCollaboratorsPropertyChange = (props: IProps) => {
  const collaborators = props.feedItem.propertyChange?.value as FeedItemIssueCollaboratorsValueDto[];

  if (collaborators == null) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> updated collaborators</span>
      </Typography>
    );
  }

  if (collaborators.length === 0) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> removed all collaborators</span>
      </Typography>
    );
  }

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated collaborators to </span>
      {[...collaborators]
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
        .map((u, i) => (
          <span key={u.userId}>
            <Link href={Links.User(u.userId)} sx={{ fontWeight: "bold" }}>
              {u.displayName}
            </Link>
            {i < collaborators.length - 1 && <span>, </span>}
          </span>
        ))}
    </Typography>
  );
};

export { IssueCollaboratorsPropertyChange };
